function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.726,0.581C27.651,0.581 33.601,2.919 33.601,5.894L33.601,9.081C34.776,9.081 35.726,10.031 35.726,11.206L35.726,15.456C35.726,16.631 34.776,17.581 33.601,17.581L33.601,28.206C33.601,29.381 32.651,30.331 31.476,30.331L31.476,32.456C31.476,33.631 30.526,34.581 29.351,34.581L27.226,34.581C26.05,34.581 25.101,33.631 25.101,32.456L25.101,30.331L12.351,30.331L12.351,32.456C12.351,33.631 11.401,34.581 10.226,34.581L8.101,34.581C6.925,34.581 5.976,33.631 5.976,32.456L5.976,30.331C4.8,30.331 3.851,29.381 3.851,28.206L3.851,17.581C2.675,17.581 1.726,16.631 1.726,15.456L1.726,11.206C1.726,10.031 2.675,9.081 3.851,9.081L3.851,5.894C3.851,2.919 9.801,0.581 18.726,0.581ZM8.101,11.206L8.101,17.581C8.101,18.756 9.05,19.706 10.226,19.706L17.663,19.706L17.663,9.081L10.226,9.081C9.05,9.081 8.101,10.031 8.101,11.206ZM19.788,19.706L27.226,19.706C28.401,19.706 29.351,18.756 29.351,17.581L29.351,11.206C29.351,10.031 28.401,9.081 27.226,9.081L19.788,9.081L19.788,19.706ZM9.163,27.144C10.339,27.144 11.288,26.194 11.288,25.019C11.288,23.843 10.339,22.894 9.163,22.894C7.988,22.894 7.038,23.843 7.038,25.019C7.038,26.194 7.988,27.144 9.163,27.144ZM28.288,27.144C29.464,27.144 30.413,26.194 30.413,25.019C30.413,23.843 29.464,22.894 28.288,22.894C27.113,22.894 26.163,23.843 26.163,25.019C26.163,26.194 27.113,27.144 28.288,27.144ZM25.101,5.894C25.101,5.309 24.622,4.831 24.038,4.831L13.413,4.831C12.829,4.831 12.351,5.309 12.351,5.894C12.351,6.478 12.829,6.956 13.413,6.956L24.038,6.956C24.622,6.956 25.101,6.478 25.101,5.894Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transport.388f50409e4145f5d9a654b5d7171cc3.svg";